import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Root, classes } from './utils';
import AgGrid from '../../common-components/common-ag-grid/AgGrid';
import accuracyDetailsColumnDef from './accuracyDetailsColumnDef';
import {
  getGridFilterSortStatus,
  getRowData,
} from '../../../../services/allInvoiceApi';
import MODELS from '../../../../constants/models';

const AccuracyDetails = () => {
  const [gridSettingData, setGridSettingData] = useState({});
  const [accuracyDetailsValue, setAccuracyDetailsValue] = useState('');
  const [documentType, setDocumentType] = useState('');
  const { docType } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    switch (docType) {
      case 'all-documents':
        setAccuracyDetailsValue('all-documents');
        setDocumentType('all-documents');
        break;
      case MODELS.BANK_STATEMENT:
        setAccuracyDetailsValue('Bank Statement');
        setDocumentType(MODELS.BANK_STATEMENT);
        break;
      case MODELS.CREDIT_CARD_STATEMENT:
        setAccuracyDetailsValue('Credit Card Statement');
        setDocumentType(MODELS.CREDIT_CARD_STATEMENT);
        break;
      case MODELS.SALES:
        setAccuracyDetailsValue('Sales');
        setDocumentType(MODELS.SALES);
        break;
      case MODELS.INVOICE:
        setAccuracyDetailsValue('Direct Expenses');
        setDocumentType(MODELS.INVOICE);
        break;
      case MODELS.RECEIPT:
        setAccuracyDetailsValue('Indirect Expenses');
        setDocumentType(MODELS.RECEIPT);
        break;
      default:
        setAccuracyDetailsValue('all-documents');
        setDocumentType('all-documents');
        break;
    }
  }, [docType]);

  useEffect(() => {
    const getFilterSortData = async () => {
      try {
        const response = await getGridFilterSortStatus(documentType);
        setGridSettingData(response);
      } catch (err) {
        return err;
      }
    };
    if (documentType) {
      getFilterSortData();
    }
  }, [documentType]);

  useEffect(() => {
    if (!accuracyDetailsValue) return;

    const newDocType = (() => {
      switch (accuracyDetailsValue) {
        case 'all-documents':
          return 'all-documents';
        case 'Bank Statement':
          return MODELS.BANK_STATEMENT;
        case 'Credit Card Statement':
          return MODELS.CREDIT_CARD_STATEMENT;
        case 'Sales':
          return MODELS.SALES;
        case 'Direct Expenses':
          return MODELS.INVOICE;
        case 'Indirect Expenses':
          return MODELS.RECEIPT;
        default:
          return 'all-documents';
      }
    })();

    if (docType !== newDocType) {
      navigate(`/accuracy-details/${newDocType}`);
    }
  }, [accuracyDetailsValue, docType, navigate]);

  const getGridKey = () => {
    switch (accuracyDetailsValue) {
      case 'all-documents':
        return 'all-documents';
      case 'Bank Statement':
        return 'bank-statements';
      case 'Credit Card Statement':
        return 'creditcardstatements';
      case 'Sales':
        return 'invoices';
      case 'Direct Expenses':
        return 'invoices';
      case 'Indirect Expenses':
        return 'receipts';
      default:
        return 'all-documents';
    }
  };
  return (
    <Root className={classes.root}>
      <Box className={classes.MainBox}>
        <AgGrid
          className={classes.accuracyDetailsAgGridStyle}
          TitleHeader="Accuracy Details"
          columnData={accuracyDetailsColumnDef}
          getRowData={getRowData}
          gridSettingData={gridSettingData}
          functionData={documentType}
          gridKey={getGridKey()}
          accuracyDetailsValue={accuracyDetailsValue}
          setAccuracyDetailsValue={setAccuracyDetailsValue}
          setGridSettingData={setGridSettingData}
        />
      </Box>
    </Root>
  );
};

export default AccuracyDetails;
